import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, FieldValues } from 'react-hook-form';
import { addressSchema } from '@shared/lib/validators/registration-schema';
import { RegisterHeader } from './RegistrationStepCompanyData';
import { Button } from '../../../shared/ui/button';
import { InputField } from '../../../shared/ui/input-field';
import {
  addLegalAddress,
  selectLegalEntityLegalAddress,
} from '../../../entities/registration/model';

export const RegistrationStepLegalAddress = () => {
  const legalAddress = useSelector(selectLegalEntityLegalAddress);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(addressSchema),
    shouldUnregister: false,
  });

  const onSubmit = (data: FieldValues) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(addLegalAddress(data as any));
  };

  useEffect(() => {
    reset(legalAddress);
  }, [legalAddress, reset]);

  return (
    <>
      <RegisterHeader isBack={true} stepSize={1} step={2} title="Юридический адрес" />
      {/* flex-col: отступы полей не схлопываются, расстояние между всеми
          полями одинаковое (90px от подписи до подписи, как в макете) —
          раньше у ряда «Дом/Офис» было 90, у остальных 74. */}
      <form className="w-full flex flex-col" onSubmit={handleSubmit(onSubmit)}>
        <InputField id="country" inputName="country" label="Страна" placeholder="Введите страну" errors={errors} register={register} />
        <InputField id="region" inputName="region" label="Регион" placeholder="Введите регион" errors={errors} register={register} />
        <InputField id="city" inputName="city" label="Город" placeholder="Введите город" type="text" errors={errors} register={register} />
        <InputField id="street" inputName="street" label="Улица" placeholder="Введите улицу" type="text" errors={errors} register={register} />
        <div className="flex w-full justify-between items-center gap-5 [&>div]:flex-1">
          <InputField id="house" inputName="house" label="Дом" placeholder="Номер дома" type="text" errors={errors} register={register} />
          <InputField id="apartment" inputName="apartment" label="Офис" placeholder="Номер офиса" type="text" errors={errors} register={register} />
        </div>
        <InputField id="postcode" inputName="postcode" label="Почтовый индекс" placeholder="Введите индекс" type="text" errors={errors} register={register} />
        <div className="flex justify-end mt-4">
          <Button type="submit" className="!w-[189px]">Продолжить</Button>
        </div>
      </form>
    </>
  );
};
